import React from 'react';

function Liberia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124072)">
        <mask
          id="mask0_800_124072"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124072)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V24H0V0Z"
            fill="#F7FCFF"
          />
          <rect x="0.0302734" y="5.5" width="36" height="3" fill="#E31D1C" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V3H0V0Z"
            fill="#E31D1C"
          />
          <rect x="-0.0664062" y="11" width="36" height="3" fill="#E31D1C" />
          <rect x="0.125488" y="16.4" width="36" height="3" fill="#E31D1C" />
          <rect x="0.114258" y="21.5" width="36" height="3" fill="#E31D1C" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H18V14H0V0Z"
            fill="#3D58DB"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.14903 9.21309L5.86249 11.2394L6.91266 7.7688L4.5 5.55178L7.76688 5.43191L9.14903 2L10.5312 5.43191H13.7925L11.3854 7.7688L12.5909 11.0346L9.14903 9.21309Z"
            fill="#F7FCFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124072">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Liberia;
